var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRestaurant = function SvgRestaurant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17.32,
    viewBox: "0 0 20 17.32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    transform: "translate(-1361 -6874.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(-606 -1564)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 6,
    cy: 1,
    rx: 6,
    ry: 1,
    transform: "translate(1967 8454)",
    fill: "#5b5b5b",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("g", {
    id: "serving-dish",
    transform: "translate(1969.346 8438.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M228.956,7.906a1,1,0,0,1-2,0C226.953,7.353,228.956,7.353,228.956,7.906Zm0,0",
    transform: "translate(-219.128 -7.233)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M53.886,44.574a7.218,7.218,0,0,0-7.218,7.218H61.1A7.218,7.218,0,0,0,53.886,44.574Zm0,0",
    transform: "translate(-45.059 -43.037)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M228.2,44.574a7.271,7.271,0,0,0-.993.068,7.219,7.219,0,0,1,6.225,7.15h1.986a7.218,7.218,0,0,0-7.218-7.218Zm0,0",
    transform: "translate(-219.373 -43.037)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M24.13,249.1H7.983a.5.5,0,0,1-.5-.5v-.315a.5.5,0,0,1,.5-.5H24.13a.5.5,0,0,1,.5.5v.315A.5.5,0,0,1,24.13,249.1Zm0,0",
    transform: "translate(-7.229 -239.248)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M38.391,291.153l.118-.506a1.942,1.942,0,0,1,1.438-1.445,5.906,5.906,0,0,1,2.188.032,4.671,4.671,0,0,0,1.994-.108l.951-.263a4.638,4.638,0,0,0,1.642-.831l1.64-1.453a.523.523,0,1,0-.67-.8l-1.614,1.069-1.6.462-1.133.025.764-.4a.619.619,0,0,0,.283-.8.6.6,0,0,0-.214-.257.643.643,0,0,0-.49-.1l-2.24.467-1.71-.461a2.584,2.584,0,0,0-.733-.14,2.7,2.7,0,0,0-1.739.766l-.005.005-2.1,2.548Zm0,0",
    transform: "translate(-33.951 -275.792)",
    fill: "#ffe7cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M84.15,288.063l-1.815,1.319c-.489.385-1.63,1.113-5.835.751a7.1,7.1,0,0,0-2.189-.032c-.562.13-1.646,1.508-2.066,2.066l1.948,1.323.119-.506a1.942,1.942,0,0,1,1.438-1.445,5.906,5.906,0,0,1,2.189.032,4.671,4.671,0,0,0,1.994-.108l.951-.263a4.639,4.639,0,0,0,1.642-.831l1.64-1.453A.56.56,0,0,0,84.15,288.063Zm0,0",
    transform: "translate(-69.755 -278.13)",
    fill: "#f4d5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M20.923,353.018l-3.3-2.242a.455.455,0,0,0-.632.121l-.482.711a.455.455,0,0,0,.121.632l3.3,2.242a.455.455,0,0,0,.632-.121l.482-.711A.455.455,0,0,0,20.923,353.018Zm0,0",
    transform: "translate(-15.864 -338.606)",
    fill: "#f03737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M83.425,393.876l-1.267-.861-.993,1.464,1.267.861a.455.455,0,0,0,.616-.1l.512-.755A.455.455,0,0,0,83.425,393.876Zm0,0",
    transform: "translate(-78.366 -379.464)",
    fill: "#f03737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M16.9,8.286h-.613a7.4,7.4,0,0,0-.677-2.677.258.258,0,1,0-.468.218,6.89,6.89,0,0,1,.628,2.459H3.941a.258.258,0,1,0,0,.516H16.9a.237.237,0,0,1,.237.237v.315a.237.237,0,0,1-.237.237H.754a.237.237,0,0,1-.237-.237V9.04A.237.237,0,0,1,.754,8.8H2.738a.258.258,0,1,0,0-.516H1.884A6.959,6.959,0,0,1,8.363,1.811h0L8.574,1.8h.041l.073,0,.139,0,.185,0,.055,0,.142.007.075,0a6.964,6.964,0,0,1,5.285,3.01.258.258,0,0,0,.426-.292A7.481,7.481,0,0,0,9.886,1.355a1.257,1.257,0,0,0,.2-.682c0-.14-.063-.4-.482-.553A2.589,2.589,0,0,0,8.05.12c-.419.154-.482.413-.482.553a1.259,1.259,0,0,0,.2.68,7.478,7.478,0,0,0-6.4,6.933H.754A.754.754,0,0,0,0,9.04v.315a.754.754,0,0,0,.753.753H3.536a3.2,3.2,0,0,0-.4.32l-.005,0a.234.234,0,0,0-.022.024L1.886,11.946a.712.712,0,0,0-.972.2l-.482.711a.714.714,0,0,0,.19.99l3.3,2.242a.708.708,0,0,0,.4.124.724.724,0,0,0,.136-.013.708.708,0,0,0,.456-.3l.482-.711a.714.714,0,0,0-.19-.99l-.019-.013a1.67,1.67,0,0,1,.869-.524,5.676,5.676,0,0,1,2.088.035,4.933,4.933,0,0,0,2.1-.113l.951-.263a4.9,4.9,0,0,0,1.733-.876l.011-.01,1.633-1.446a.8.8,0,0,0,.243-.881H16.9a.754.754,0,0,0,.753-.753V9.04a.754.754,0,0,0-.753-.753ZM8.828.517a1.21,1.21,0,0,1,.743.167.744.744,0,0,1-.329.607l-.151-.007-.051,0c-.072,0-.143,0-.213,0l-.151,0-.074,0-.089,0-.1,0A.743.743,0,0,1,8.084.684,1.21,1.21,0,0,1,8.828.517Zm1.852,9.716a.852.852,0,0,0-.068-.125h2.477l-1.071.709-1.527.442h-.052a.879.879,0,0,0,.241-1.027Zm-2.8-.125-.373.078-.288-.078ZM4.967,14.9l-.482.711a.2.2,0,0,1-.274.052l-3.3-2.242a.2.2,0,0,1-.052-.273l.482-.711a.2.2,0,0,1,.126-.083.2.2,0,0,1,.037,0,.2.2,0,0,1,.11.034l.178.121h0l3.121,2.12a.2.2,0,0,1,.052.273Zm9.292-4.319-.018.014-1.634,1.448a4.383,4.383,0,0,1-1.545.78l-.951.263a4.409,4.409,0,0,1-1.883.1,6.149,6.149,0,0,0-2.289-.029,2.194,2.194,0,0,0-1.182.736L2.315,12.237,3.5,10.8a2.431,2.431,0,0,1,1.561-.69h.011a1.947,1.947,0,0,1,.536.1l.114.031,1.71.461a.258.258,0,0,0,.12,0l2.24-.467a.385.385,0,0,1,.293.057.347.347,0,0,1,.123.147.361.361,0,0,1-.167.467l-.764.4A.258.258,0,0,0,9.4,11.8l1.133-.025a.26.26,0,0,0,.066-.01l1.6-.462a.259.259,0,0,0,.071-.033L13.881,10.2c.135-.084.315-.152.411-.011a.307.307,0,0,1-.033.389Zm0,0",
    transform: "translate(0 0)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestaurant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restaurant.93614bcb.svg";
export { ForwardRef as ReactComponent };